import { EMPTY_OBJECT } from '../../../../../constants/common'

export function calculateHeaderElementsVisibility({
  offset,
  rules,
  screenWidth,
  userMenuWidth,
}) {
  const availableWidth = screenWidth - userMenuWidth - offset

  return rules.reduce((acc, rule) => {
    const shouldHide = availableWidth < rule.minAvailableWidth

    return {
      ...acc,
      [rule.key]: shouldHide,
    }
  }, EMPTY_OBJECT)
}
